import { Grid, html, h } from 'gridjs';

if (document.getElementById('orders-table')) {
  const orders = document.getElementById("orders-table").dataset.orders;

  new Grid({
    columns: [
      /*{
        name: "Order Date",
        id: 'orderDate',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
        width: '180px'
      },*/
      { 
        name: "Order ID",
        //id: 'id',
        id: 'reference2',
        formatter: (cell) => {
          var id = cell.split("|")[2];
          var ref = cell.split("|")[1];
          return html(`<a href="/rd/order?id=${id}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">${ref}</a>`);
        },
        width: '100px'
      },
      {
        name: "Account Name",
        id: 'customerName',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
        width: '180px'
      },
      {
        name: "RD Email",
        id: 'rdEmail',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "Product Types",
        id: 'campaignName',
        width: '100px',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },

      {
        name: "Order Status",
        id: 'orderStatus',
        width: '120px',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "Allocatable?",
        id: 'allocation',
        width: '100px',
        formatter: (cell, row) => {
          let status = row.cells[4].data;

          if (cell && status !== 'Allocated' && status !== 'Delivered' && status !== 'PO Needed' && status !== 'Estimated Shipping Provided') {
            return html(`<a href="/rd/orders/allocation/${cell}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">Yes</a>`);
          } else {
            return html(`<a href="#" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-red py-2 px-4 uppercase w-20 mx-auto justify-center cursor-not-allowed" disabled>No</a>`);
          }
        },
      }
    ],
    sort: true,
    search: true,
    fixedHeader: true,
    data: JSON.parse(orders),
    pagination: {
      enabled: true,
      limit: 10,
      summary: true
    }
  }).render(document.getElementById("orders-table"));
}

if (document.getElementById("needs-allocation-table")) {
  const orders = document.getElementById("needs-allocation-table").dataset.orders;

  new Grid({
    columns: [
      /*{ 
        name: "Order ID-BOB",
        id: 'reference',
        //formatter: (cell, row) => {
          //return html(`<a href="/rd/order?id=${cell.id}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">${cell.ref}</a>`);
        //},
        formatter: (cell) => html(`<a href="/rd/order?id=${cell}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">${cell}</a>`),
        width: '100px'
      },*/
      { 
        name: "Order ID",
        //id: 'id',
        id: 'reference2',
        formatter: (cell) => {
          var id = cell.split("|")[2];
          var ref = cell.split("|")[1];
          return html(`<a href="/rd/order?id=${id}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">${ref}</a>`);
        },
        width: '100px'
      },
      {
        name: "Ordered Date",
        id: 'orderedDate',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "Account Name",
        id: 'accountName',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "RD Email",
        id: 'rdEmail',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "Product Type",
        id: 'campaignName',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "Allocated",
        id: "allocated",
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`)
      },
      {
        name: "Remaining",
        id: "remaining",
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`)
      },
      {
        name: "Action Needed?",
        id: 'allocation',
        formatter: (cell, row) => {
          if (cell) {
            return html(`<a href="/rd/orders/allocation/${cell}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">Yes</a>`);
          } else {
            return h ('button', {
              className: 'rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-red py-2 px-4 uppercase w-20 mx-auto justify-center disabled cursor-not-allowed'
            },
            'No');
          }
        },
      }
    ],
    sort: true,
    search: true,
    fixedHeader: true,
    data: JSON.parse(orders),
    pagination: {
      enabled: true,
      limit: 10,
      summary: true
    }
  }).render(document.getElementById("needs-allocation-table"));
}

if (document.getElementById("completed-table")) {
  let orders = JSON.parse(document.getElementById('completed-table').dataset.orders);

  orders = orders.sort((item1, item2) => {
    if (item1.allocatedId > item2.allocatedId) return -1;
	  if (item1.allocatedId < item2.allocatedId) return 1;
  });

  new Grid({
    columns: [
      /*{ 
        name: "Order ID",
        //id: 'reference',
        id: 'reference',
        formatter: (cell) => html(`<a href="/rd/order?id=${cell.id}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">${cell.ref}</a>`),
        width: '100px'
      },*/
      { 
        name: "Order ID",
        //id: 'id',
        id: 'reference2',
        formatter: (cell) => {
          var id = cell.split("|")[2];
          var ref = cell.split("|")[1];
          return html(`<a href="/rd/order?id=${id}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">${ref}</a>`);
        },
        width: '100px'
      },
      { 
        name: "Allocated ID",
        id: 'allocatedId',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
        width: '150px'
      },
      {
        name: "Ship To Name",
        id: 'accountName',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
        width: '150px'
      },
      {
        name: "RD Name",
        id: 'rd',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "Product Type",
        id: 'campaignName',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "Allocation Status",
        id: 'allocatedOrderStatus',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`)
      },
      {
        name: "Order Status",
        id: 'status',
        formatter: (cell, row) => {
          if (cell === 'In Transit') {
            return html(`<p class="text-sm font-bold text-red">${cell}</p>`);
          } else {
            return html(`<p class="text-sm font-bold text-green">${cell}</p>`);
          }
        }
      }
    ],
    sort: true,
    search: true,
    fixedHeader: true,
    data: orders,
    pagination: {
      enabled: true,
      limit: 10,
      summary: true
    }
  }).render(document.getElementById("completed-table"));
}

if (document.getElementById("delivered-table")) {
  new Grid({
    columns: [
      /*{ 
        name: "Order ID",
        id: 'id',
        formatter: (cell) => html(`<a href="/rd/order?id=${cell}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">${cell}</a>`),
        width: '100px'
      },*/
      { 
        name: "Order ID",
        //id: 'id',
        id: 'reference2',
        formatter: (cell) => {
          var id = cell.split("|")[2];
          var ref = cell.split("|")[1];
          return html(`<a href="/rd/order?id=${id}" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase w-20 mx-auto justify-center">${ref}</a>`);
        },
        width: '100px'
      },
      { 
        name: "Allocated ID",
        id: 'allocatedId',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
        width: '150px'
      },
      {
        name: "Ship To Name",
        id: 'accountName',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
        width: '150px'
      },
      {
        name: "RD Name",
        id: 'rdName',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
      },
      {
        name: "Product Type",
        id: 'campaignName',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`),
        width: '150px'
      },
      {
        name: "Delivered Date",
        id: 'dateDelivered',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`)
      },
      {
        name: "Allocation Status",
        id: 'allocatedOrderStatus',
        formatter: (cell) => html(`<p class="text-base">${cell}</p>`)
      },
      {
        name: "Order Status",
        id: 'status',
        formatter: (cell) => html(`<p class="text-sm font-bold text-red">${cell}</p>`)
      },
    ],
    sort: true,
    search: true,
    fixedHeader: true,
    data: JSON.parse(document.getElementById("delivered-table").dataset.orders),
    pagination: {
      enabled: true,
      limit: 10,
      summary: true
    }
  }).render(document.getElementById("delivered-table"));
}